import { progressItems, type ProgressItem } from '../lib/progress.js';
import { StepNavigation, StepProgress } from './StepProgress.js';

export function PlannerPlaceholder({ id }: { id: ProgressItem['id'] }) {
  const currentIndex = progressItems.findIndex((candidate) => candidate.id === id);
  if (currentIndex < 0) {
    throw new Error(`Unknown planner destination: ${id}`);
  }
  const item = progressItems[currentIndex];

  return (
    <>
      <StepProgress currentIndex={currentIndex} />
      <main className="mx-auto flex w-full max-w-5xl flex-1 flex-col px-4 py-10 sm:py-12">
        <div>
          <h1 className="text-2xl font-semibold sm:text-3xl">{item.label}</h1>
          <p className="mt-4 text-sm text-gray-600">{item.placeholder}</p>
        </div>
        <StepNavigation currentIndex={currentIndex} />
      </main>
    </>
  );
}
